<template>
  <v-container fluid style="height:100%" pa-0 ma-0>
        <ProductsTable/>
  </v-container>  
</template>
<script>
//import { mapFields,mapMultiRowFields } from 'vuex-map-fields'
import ProductsTable from './../../components/blocks/ProductsTable'
export default {
    components: {
      ProductsTable
    },
    data () {
      return {
        autogrow:true,
        clipped: false,
        email: '',
        password: '',
        passwordConfirm: '',
        isTopBarFlat:true,
        clipped: true,
        clippedToolbar:true,
        alert: false,
        right: true,
        hideSlider:true,
        miniVariant: true,
        rightDrawer: true,
      }
    },
    mounted() {
    },
    computed: {},
    created () {},
    methods: {
      
      example(message) {
        
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/views/Products.vue